import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { SocialMediaAccounts } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia`,
    request: {} as
      | SocialMediaAccounts.Post.FacebookAccountPayload
      | SocialMediaAccounts.Post.InstagramAccountPayload
      | SocialMediaAccounts.Post.YouTubeAccountPayload,
  },
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia`,
    response: [] as SocialMediaAccounts.Get.Response[],
  },
};

export const id = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/@id`,
    params: {} as { id: string },
    response: {} as SocialMediaAccounts.Get.Response,
  },
  [HTTP_METHODS.PATCH]: {
    method: HTTP_METHODS.PATCH,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/@id`,
    params: {} as { id: string },
    request: {} as SocialMediaAccounts.Patch.Request,
  },
  [HTTP_METHODS.PUT]: {
    method: HTTP_METHODS.PUT,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/@id`,
    params: {} as { id: string },
    request: {} as SocialMediaAccounts.Put.Request,
  },
  [HTTP_METHODS.DELETE]: {
    method: HTTP_METHODS.DELETE,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/@id`,
    params: {} as { id: string },
  },
};
